import React from 'react';

const AsAdmin = () => {
    return (
        <div>Inloggen als admin....</div>
    )
}

export default AsAdmin;